// extracted by mini-css-extract-plugin
export var readonly = "_ei-1";
export var star = "_ei-0";